import { PromotionCreative } from "@/app/Promotions/GraphQL/promotionCreativeQuery";
import { cn } from "@/lib/utils";
import { useTranslations } from "use-intl";

export function AdPreviewCard({
  creative,
  className,
}: {
  creative: PromotionCreative;
  className?: string;
}) {
  const t = useTranslations("promotion.dialog");

  return (
    <div
      className={cn(
        "mx-auto max-w-sm overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm",
        className,
      )}
    >
      {creative.image_url ? (
        <img
          src={creative.image_url}
          alt={creative.title}
          className="aspect-square w-full object-cover"
        />
      ) : (
        <div className="flex aspect-square w-full items-center justify-center bg-gray-100 px-4 text-center text-sm text-gray-400">
          {t("previewNoImage")}
        </div>
      )}

      <div className="flex items-center gap-3 border-t border-gray-100 bg-gray-50 px-3 py-2.5">
        <div className="min-w-0 flex-1">
          <p className="truncate text-xs uppercase tracking-wide text-gray-500">
            {new URL(creative.target_url).hostname.replace(/^www\./, "")}
          </p>
          <p className="truncate text-sm font-semibold text-gray-900">
            {creative.title}
          </p>
          <p className="line-clamp-2 text-xs text-gray-600">{creative.body}</p>
        </div>

        <span className="shrink-0 rounded-md bg-gray-200 px-3 py-1.5 text-xs font-semibold text-gray-700">
          {t("previewCta")}
        </span>
      </div>
    </div>
  );
}
